import { render, staticRenderFns } from "./ObservationOne.vue?vue&type=template&id=7c073518&scoped=true&"
import script from "./ObservationOne.vue?vue&type=script&lang=js&"
export * from "./ObservationOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c073518",
  null
  
)

export default component.exports